<template>
  <div id="returnList">
    <div v-show="!childShow">
      <table-title>筛选栏</table-title>
      <Form :model="queryParams" inline :label-width="90">
        <FormItem label="租借人">
          <leasee-select roleType="LEASEE" v-model="queryParams.leaseeId" />
        </FormItem>
        <FormItem label="状态">
          <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="recycleAppointment.RecycleStatus" :exclusion="[]" v-model="queryParams.status" />
        </FormItem>
        <br />
        <FormItem label="标的物小类">
          <target-type-select @on-change="onTargetType" v-model="queryParams.targetType" />
        </FormItem>
        <FormItem label="创建时间">
          <DatePicker type="daterange" placeholder="请选择" split-panels :editable="false" @on-change="onCreateTime" style="width:200px"></DatePicker>
        </FormItem>
        <br />
        <FormItem label="回收方式">
          <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="recycleAppointment.RecycleMethod" :exclusion="[]" v-model="queryParams.recycleMethod" />
        </FormItem>
        <FormItem label="备注搜索">
          <Input v-model="queryParams.remarkLike" placeholder="根据备注模糊搜索" clearable style="width: 200px" />
        </FormItem>
        <Button type="primary" style="margin-left:20px" @click="search">查询</Button>
      </Form>
      <!-- 租赁列表 -->
      <table-title>归还订单列表</table-title>
      <data-grid ref="returnList" :columns="cols" :queryParams="queryParams" paramsName="param" :queryUrl="queryUrl" exportFileName="归还订单" exportId="queryRecycleAppointmentsMember" :dataList="[]">
        <template #default="{columns, data}">
          <Table :columns="columns" :data="data" border stripe size="small">
            <template #id="{row,index}">
              <span style="color:#2D8CF0;cursor:pointer" @click="goOrderDetail(row.id)">{{row.id}}</span>
            </template>
            <template #storageId="{row,index}">
              <span style="color:#2D8CF0;cursor:pointer" @click="queryStorage(row)">{{row.storageId | houseFilter }}</span>
            </template>
            <template #contactId="{row,index}">
              <span style="color:#2D8CF0;cursor:pointer" @click="queryContact(row.contactId)">{{row.contactId | contactFilter}}</span>
            </template>
            <template #recycledAmount="{row}">
              <a href="javascript:;" v-if="row.recycledAmount > 0 && row.recycleMethod === 'SELF_DELIVERY'" class="hoverCollection" style="color: #2d8cf0;padding:35px" @click="toRecord(row.id)">{{row.recycledAmount}}</a>
              <span v-else>{{row.recycledAmount}}</span>
            </template>
            <template slot-scope="{row}" slot="status">
              <Tag color="gold" v-if="row.status === 'TO_CONFIRM'">待确认</Tag>
              <Tag color="gold" v-if="row.status === 'TO_RECEIVE'">回收中</Tag>
              <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
              <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
              <Tag color="red" v-if="row.status === 'CANCEL'">取消</Tag>
            </template>
            <template slot-scope="{row}" slot="operation">
              <Button type="warning" size="small" v-if="row.status === 'TO_CONFIRM' && row.inputUser == userId" @click="onModification(row.id)">修改</Button>
              <Button type="info" size="small" v-show="row.recycleMethod === 'DEPOSIT'" style="margin-left:5px" @click="onQueryLogistics(row)">查看物流</Button>

              <!-- <Button type="primary" size="small" v-if="row.status === 'TO_CONFIRM' && confirmButton" @click="orderConfirms(row)">预约确认</Button>
                            <Button type="success" size="small" v-if="row.recycleMethod === 'SELF_DELIVERY' && row.status === 'TO_RECEIVE' && confirmButton" style="margin-left:5px" @click="affirmClick(row)">自送确认</Button>
                            <Button type="warning" size="small" v-if="row.recycleMethod === 'SELF_DELIVERY' && row.status === 'TO_RECEIVE' && confirmButton" style="margin-left:5px" @click="stop(row.id)">中止</Button> -->
            </template>
          </Table>
        </template>
      </data-grid>
      <auto-return :autoReturn="autoReturn" @serch="search" />
      <contact-detail ref="queryContactRef" />
      <storage-detail ref="queryStorageRef" :contactShow="true" />
      <to-record ref="toRecordRef" />
      <query-logistics ref="queryLogisticsRef" />
    </div>
    <div v-if="childShow">
      <component v-bind:is="currentChild" :paramsData="currentData" @onFinish="onFinish"></component>
    </div>
  </div>
</template>
<script>
import tableTitle from 'components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
import dictSelect from '@/components/select/dict-select.vue'
import leaseeSelect from '@/components/select/payee-select.vue'
import targetTypeSelect from '@/components/select/targetTypeSelect'
import contactDetail from '@/components/contact-detail'
import storageDetail from '@/components/storage-detail'
import autoReturn from '@/viewsComponent/lease/returnManagement/autoReturn'
import toRecord from '@/components/toRecord.vue'

import orderConfirm from './orderConfirm.vue'
import returnOrderDetail from './returnOrderDetail'
import modification from './modification'
import queryLogistics from './component/queryLogistics'

let that
export default {
  name: "returnList",
  components: {
    tableTitle,
    dataGrid,
    dictSelect,
    leaseeSelect,//租借人
    targetTypeSelect,
    autoReturn,
    contactDetail,
    storageDetail,
    orderConfirm,//预约确认
    toRecord,//查看自提记录
    returnOrderDetail,
    modification,//修改
    queryLogistics,//查看物流信息
  },
  data() {
    return {
      userId: "",
      confirmButton: false,//限制列表操作按钮
      houseList: [],//仓库
      contactList: [],//联系人
      autoReturn: {
        show: false,
        data: {}
      },
      childShow: false,
      currentChild: "",
      currentData: "",
      queryUrl: "MID-OPERATE-LEASE/messageService/recycleService/queryRecycleAppointments",
      queryParams: {
        leaseeId: "",
        targetType: "",
        status: "",
        createDateBegin: "",
        createDateEnd: "",
      },
      cols: [
        { title: '归还预约单号', slot: "id" },
        { title: '仓库名称', slot: "storageId" },
        { title: "仓库所在区域", key: "storageArea", dict:['region', 'fullArea', true] },
        { title: "仓库详细地址", key: "storageAddress" },
        { title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member', true] },
        { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true], },
        { title: '预约归还总数', key: 'totalAmount' },
        { title: '确认停租数', slot: 'recycledAmount' },
        { title: "实际上门回收数量", key: 'depositRecycleAmount' },
        { title: '租借方联系人', slot: 'contactId' },
        { title: '申请回收时间', key: 'expectedBillingUntil', formatter: 'date' },
        { title: '最迟停租时间', key: 'confirmedBillingUntil', formatter: 'date' },
        { title: '状态', slot: 'status' },
        { title: '回收方式', key: 'recycleMethod', dict: ['ENUM_MID-OPERATE-LEASE', 'recycleAppointment.RecycleMethod'] },
        { title: '创建日期', key: "createTime", formatter: 'date' },
        { title: '备注', key: 'recycleAppointmentComment' },
        { title: '操作', slot: 'operation', width: 200 },
      ],
    }
  },
  beforeCreate() {
    that = this
  },
  filters: {
    houseFilter(code) {
      if (code)
        return that.houseList.filter(item => item.code === code)[0].text;
    },
    contactFilter(code) {
      if (code)
        return that.contactList.filter(item => item.code === code)[0].text;
    },
  },
  async created() {
    this.userId = sessionStorage.getItem('userId')
    await this.getHouse()
    await this.getContat()
    this.getButton()
  },

  methods: {
    // 查看物流
    onQueryLogistics(data) {
      this.$refs['queryLogisticsRef'].openModal(data);

    },
    // 修改
    onModification(row) {
      this.currentChild = modification;
      this.childShow = true;
      this.currentData = row;
    },
    // 查看自提记录
    toRecord(id) {
      let data = {
        url: "http://MID-OPERATE-LEASE/messageService/recycleService/querySelfDeliveryRecordsByRecycleAppointment",
        body: { recycleAppointmentId: id }
      }
      this.$refs['toRecordRef'].openModal(data)
    },
    // 权限按钮
    getButton() {
      JSON.parse(sessionStorage.getItem('menuList')).map(item => {
        if (item === 'returnManagementButtons') {
          this.confirmButton = true
        }
      })

    },
    //仓库转码
    async getHouse() {
      let data = {
        url: "CORE-COMMON/messageService/dictService/queryEntries",
        body: {
          codes: [],
          namespace: "bizObjects",
          superCode: "",
          type: "warehouse"
        }
      }
      this.houseList = await this.invoke(data)
    },
    //联系人contat
    async getContat() {
      let data = {
        url: "CORE-COMMON/messageService/dictService/queryEntries",
        body: {
          codes: [],
          namespace: "bizObjects",
          superCode: "",
          type: "contact"
        }
      }
      this.contactList = await this.invoke(data)
    },

    // 创建时间
    onCreateTime(val) {
      this.queryParams.createDateBegin = val[0],
        this.queryParams.createDateEnd = val[1]
    },
    // 标的物小类
    onTargetType(params) {
      this.queryParams.targetType = params
    },
    search() {
      this.$refs['returnList'].loadFirstPage()
    },
    onFinish() {
      this.search()
      this.childShow = false
    },
    queryStorage(row) {
      this.$refs['queryStorageRef'].openModal(row.storageId)

    },
    // 联系人
    queryContact(storageContactId) {
      this.$refs['queryContactRef'].openModal(storageContactId)
    },
    // 自送确认
    affirmClick(row) {
      this.autoReturn.show = true
      this.autoReturn.data = row
      this.autoReturn.leaseeId = this.$options.filters['queryDict']('bizObjects', 'member', row.leaseeId)
      this.autoReturn.targetType = this.$options.filters['queryDict']('target', 'type', row.targetType)
    },
    // 中止
    stop(id) {
      let data = {
        url: 'MID-OPERATE-LEASE/messageService/recycleService/selfDeliveryTerminate',
        body: { recycleAppointmentId: id }
      }
      this.$Modal.confirm({
        title: '确定要中止吗?',
        onOk: () => {
          this.invoke(data).then(res => {
            if (!res) {
              this.$Message.success('该订单中止成功！')
              this.search()
            }
          })
        },
      });
    },
    // 预约确认
    orderConfirms(row) {
      this.currentChild = orderConfirm;
      this.childShow = true;
      this.currentData = row
    },
    // 订单详情
    goOrderDetail(id) {
      this.currentChild = returnOrderDetail;
      this.childShow = true;
      this.currentData = id;
    }
  }
};
</script>
<style lang="scss" scoped>
.hoverCollection:hover {
  text-decoration: underline;
}
</style>